<section class="relative w-full h-full overflow-hidden select-none">
  <div class="relative w-full h-full">
    @for (slide of mainSlideList; track i; let i = $index) {
      @switch (slide.type) {
        @case (MediaType.Image) {
          <img
            class="absolute inset-0 w-full h-full object-cover fade-slide"
            [class.opacity-100]="i === index() && animated()"
            [class.opacity-0]="i !== index() || !animated()"
            [src]="slide.src"
            [alt]="slide.alt || 'slide ' + (i + 1)"
            (load)="markLoaded(i)"
            draggable="false"
          />
        }
        @case (MediaType.Video) {
          <video
            #bannerVideo
            autoplay
            [muted]="true"
            playsinline
            class="absolute inset-0 w-full h-full object-cover fade-slide no-zoom"
            [class.opacity-100]="i === index()"
            [class.opacity-0]="i !== index()"
            (ended)="handleVideoEnded(i)"
            [poster]="slide.poster"
            [src]="slide.src"
          >
            <source [src]="slide.src" type="video/webm" />
          </video>
        }
      }
      @if (i === index()) {
        <div
          class="relative max-w-[1280px] h-full flex flex-col gap-[64px] justify-center items-center z-20 px-[20px] py-[32px] md:px-[40px] md:py-[128px] mx-auto w-full"
        >
          <div class="w-full h-fit flex flex-col gap-[24px] animated fadeInUp justify-center items-center md:items-start flex-1 md:flex-none">
            <div class="w-full h-fit flex flex-col pl-[8px] gap-[16px] items-center md:items-start">
              <div class="flex text-[20px] h-[28px] md:text-[32px] md:h-[48px] gap-[4px] md:gap-[8px]">
                @if (slide.platform === PlatformType.Edu) {
                  <span class="text-white">{{ 'Tooning' }}</span>
                } @else {
                  <img src="/images/common/tooning-plus-logo.svg" class="w-[170px] h-[28px] md:w-[292px] md:h-[48px]" alt="plus-logo" />
                }
                <span class="font-bold {{ slide.css }}-title-text">{{ slide.serviceTitle }}</span>
              </div>
              <div class="flex flex-col text-white items-center md:items-start">
                <span class="break-keep text-center text-[24px] leading-8 md:text-[56px] md:leading-20 md:text-start"> {{ slide.titleExplain }}</span>
                <span class="text-[24px] leading-8 md:text-[56px] md:leading-20 font-bold"> {{ slide.title }}</span>
              </div>
            </div>
            <div
              (click)="goToService(slide.site)"
              class="rounded-[64px] py-[12px] pl-[20px] pr-[12px] md:py-[16px] md:pl-[24px] md:pr-[16px] w-fit h-[48px] md:h-[60px] {{
                slide.css
              }}-go-button text-white flex justify-center items-center text-[16px] md:text-[20px] font-medium gap-[4px] cursor-pointer"
            >
              <span> {{ 'home.go-to-site' | translate }}</span>
              <img src="/images/common/arrow-next-white.svg" class="w-[24px] h-[24px] md:w-[28px] md:h-[28px]" alt="arrow" />
            </div>
          </div>

          <div class="flex px-[8px] gap-[16px] w-full h-[40px] items-center text-white justify-between md:justify-start">
            <div class="flex gap-[16px] items-center">
              <span class="text-[16px] font-medium w-[24px] h-[24px] flex justify-center items-center">
                {{ (index() + 1).toString().padStart(2, '0') }}</span
              >
              <div class="relative w-[min(40vw,128px)] h-[2px] bg-white/30 rounded">
                <span
                  class="absolute left-0 top-0 h-full bg-white rounded"
                  [style.width.%]="progressPercent()"
                  style="transition: width 0.32s ease"
                ></span>
              </div>
              <span class="text-[16px] font-medium w-[24px] h-[24px] flex justify-center items-center">
                {{ mainSlideList.length.toString().padStart(2, '0') }}</span
              >
            </div>

            <div class="flex gap-[16px]">
              <p-button [styleClass]="'only-icon-transparent'" [style]="{ width: '40px', height: '40px', padding: '8px' }" (click)="prev()">
                <img src="/images/common/arrow-next-white.svg" alt="menu" class="w-[24px] rotate-[180deg]" />
              </p-button>
              <p-button [styleClass]="'only-icon-transparent'" [style]="{ width: '40px', height: '40px', padding: '8px' }" (click)="next()">
                <img src="/images/common/arrow-next-white.svg" alt="menu" class="w-[24px]" />
              </p-button>
            </div>
          </div>
        </div>
      }
    }
    <div class="pointer-events-none absolute inset-0 z-10 bg-black/50"></div>
  </div>
</section>
